<template>
  <b-modal ref="mdlRsaPazienteArmadiettoRicevute" :title="title" centered no-close-on-backdrop no-close-on-esc
    hide-header-close size="xl">
    <div class="sa-tab-scroll">
      <div class="b-table-sticky-header" v-if="modalStep === 0">
        <b-table sticky-header ref="tblRigheDocumento" stacked="xl" striped hover :items="jsonData.righeDocumento"
          :fields="fieldsRigheDocumento" :current-page="1" :per-page="100000" sort-icon-left head-variant="light"
          class="sa-b-table">
          <template #cell(index)="jsonData">
            {{ jsonData.index + 1 }}
          </template>
          <template #cell(action)="row">
            <b-button v-if="row.index === jsonData.righeDocumento.length - 1" size="sm"
              variant="btn btn-success waves-effect waves-light width-sm no-text" @click="onAddRigaDocumento(row)">
              <b-icon icon="plus"></b-icon>
            </b-button>
          </template>
        </b-table>
      </div>
      <div v-if="modalStep === 1">
        <b-row>
          <b-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
            <label class="sa-label-data">{{ this.$i18n.t("billing.lblProductCode") }}</label>
            <b-form-select id="inline-form-custom-select-pref" v-model="rigaSelezionata.codiceArticolo"
              class="mb-2 mr-sm-2 mb-sm-0" :options="articoliOptions" :value="null" text-field="descrizioneArticolo"
              value-field="codiceArticolo" @change="onChangeArticolo"></b-form-select>
          </b-col>
          <b-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
            <label class="sa-label-data">{{ this.$i18n.t("billing.lblDescription") }}</label>
            <b-form-input type="text" v-model="rigaSelezionata.descrizione" placeholder="Descrizione"
              disabled></b-form-input>
          </b-col>
          <b-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
            <label class="sa-label-data">{{ this.$i18n.t("billing.lblUnitOfMeasure") }}</label>
            <b-form-select id="inline-form-custom-select-pref" v-model="rigaSelezionata.descrizioneUm"
              class="mb-2 mr-sm-2 mb-sm-0" :options="umOptions" :value="null" text-field="text"
              value-field="value"></b-form-select>
          </b-col>
          <b-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
            <label class="sa-label-data">{{ this.$i18n.t("billing.lblQuantity") }}</label>
            <b-form-input type="number" v-model="rigaSelezionata.quantita" placeholder="Quantità" required
              name="quantita" @change="onCalcolo"></b-form-input>
          </b-col>
          <b-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
            <label class="sa-label-data">{{ this.$i18n.t("billing.lblMultiplier") }}</label>
            <b-form-select id="inline-form-custom-select-pref" v-model="rigaSelezionata.multiploMultiplo"
              class="mb-2 mr-sm-2 mb-sm-0" :options="multiploOptions" :value="null" text-field="text"
              value-field="value"></b-form-select>
          </b-col>
          <b-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
            <label class="sa-label-data">{{ this.$i18n.t("billing.lblUnitPrice") }}</label>
            <b-input-group size="md" prepend="€">
              <b-form-input step="0.01" type="number" v-model="rigaSelezionata.prezzoUnitario"
                placeholder="Prezzo Unitario" required name="prezzoUnitario" @change="onCalcolo"></b-form-input>
            </b-input-group>
          </b-col>
          <b-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
            <label class="sa-label-data">{{ this.$i18n.t("billing.lblDiscountPercentage") }}</label>
            <b-input-group size="md" append="%">
              <b-form-input step="0.01" type="number" v-model="rigaSelezionata.sconto" class="form-control"
                @change="onCalcolo"></b-form-input>
            </b-input-group>
          </b-col>
          <!-- <b-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
                                    <label class="sa-label-data">{{ this.$i18n.t("billing.lblTotalLineAmount") }}</label>
                                    <b-form-input step="0.001" type="number" v-model="rigaSelezionata.totaleRiga" placeholder="Totale Riga" readonly></b-form-input>
                                </b-col> -->
          <b-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
            <label class="sa-label-data">{{ this.$i18n.t("billing.lblIva") }}</label>
            <b-form-select id="inline-form-custom-select-pref" v-model="rigaSelezionata.codiceIva"
              class="mb-2 mr-sm-2 mb-sm-0" :options="codiceIvaOptions" :value="null" text-field="text"
              value-field="value"></b-form-select>
          </b-col>
          <b-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
            <label class="sa-label-data">Imballo</label>
            <b-form-select id="inline-form-custom-select-pref" v-model="rigaSelezionata.descrizioneImballo"
              class="mb-2 mr-sm-2 mb-sm-0" :options="imballoOptions" :value="null" text-field="text"
              value-field="value"></b-form-select>
          </b-col>
          <!-- <b-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
                        <label class="sa-label-data">{{ this.$i18n.t("billing.lblTipoSpesa") }}</label>
                        <b-form-select id="inline-form-custom-select-pref" v-model="rigaSelezionata.codiceTipoSpesa" class="mb-2 mr-sm-2 mb-sm-0" :options="tipiSpesaOptions" :value="null" text-field="descrizioneTipoSpesa" value-field="id"></b-form-select>
                    </b-col> -->
        </b-row>
      </div>
    </div>
    <template #modal-footer>
      <b-button variant="outline-danger" @click="onCloseModal" v-if="modalStep === 0">Annulla</b-button>
      <b-button variant="outline-success" @click="onClickSave()" v-if="modalStep === 0">Salva</b-button>
      <b-button variant="outline-secondary" @click="onClickBack()" v-if="modalStep === 1">Indietro</b-button>
      <b-button variant="outline-success" @click="onClickAggiungi()" v-if="modalStep === 1">Aggiungi</b-button>
    </template>
    <modal-error ref="cmpModalError"></modal-error>
  </b-modal>
</template>

<script>
// import DatePicker from "vue2-datepicker";
import axios from "axios";
import UtilityMixin from "../../../utility/UtilityMixin";
import ModalError from "../../../../template/components/modal/components/ModalError.vue";
export default {
  mixins: [UtilityMixin],
  components: { ModalError },
  data() {
    return {
      pathResource: "/contabilitadocumenti",
      pathResourceAccettazione: "/accettazioni",
      pathResourceUmArticolo: "/magazzinoarticolium",
      pathResourceMultiploArticolo: "/magazzinoarticolimultipli",
      pathResourceImballoArticolo: "/magazzinoarticoliimballi",
      pathResourceArticolo: "/magazzinoarticoli",
      pathResourceTabellaIVA: "/tabellaiva",
      idAccettazione: null,
      modalStep: 0,
      umOptions: [],
      multiploOptions: [],
      imballoOptions: [],
      codiceIvaOptions: [],
      articoliOptions: [],
      rigaSelezionata: {},
      jsonData: {
        stato: "",
        note: "",
        codiceOperazioneMagazzino: 0,
        codiceOperazioneContabile: 0,
        ibanStruttura: "",
        emailStruttura: "",
        telefonoStruttura: "",
        pecStruttura: "",
        colli: 0,
        imballo: "",
        vettore: "",
        porto: "",
        noteInterne: "",
        idTipoDocumento: "",
        tipoDocumentoDescrizione: "",
        codiceStruttura: "",
        denominazioneStruttura: "",
        dataDocumento: 0,
        codiceTipoDocumento: "",
        idSoggetto: "",
        nomeSoggetto: "",
        cognomeRagioneSoggetto: "",
        provinciaSoggetto: "",
        localitaSoggetto: "",
        localitaSoggettoCodiceIstat: "",
        capSoggetto: "",
        indirizzoSoggetto: "",
        codiceFiscaleSoggetto: "",
        partitaIvaSoggetto: "",
        codiceDestinatario: "",
        idCausaleDocumento: "",
        causaleDocumentoDescrizione: "",
        causaleDocumentoOperazioneContabile: 0,
        causaleDocumentoOperazioneMagazzino: 0,
        idMetodoPagamento: "",
        metodoPagamentoDescrizione: "",
        totaleImponibileDocumento: 0.0,
        totaleImpostaDocumento: 0.0,
        totaleDocumento: 0.0,
        idMagazzino: "",
        magazzinoDescrizione: "",
        descrizioneBancaStruttura: "",
        capDestinazione: "",
        indirizzoDestinazione: "",
        localitaDestinazioneCodiceIstat: "",
        localitaDestinazione: "",
        provinciaDestinazione: "",
        speseTrasporto: 0.0,
        trasportoCura: "",
        trasportoDataOraInizio: "",
        marcaBollo: "",
        marcaBolloImporto: 0.0,
        marcaBolloImportoMinimo: 0.0,
        marcaBolloNumero: "",
        marcaBolloVirtuale: false,
        partitaIvaStruttura: "",
        codiceCausale: "",
        trasportoCausale: "",
        righeDocumento: [
          {
            aliquotaIva: 0.0,
            descrizioneImballo: "",
            codiceArticolo: "",
            codiceIva: "",
            codiceTipoSpesa: "",
            colli: 0,
            descrizioneIva: "",
            descrizioneMultiplo: "",
            multiploMultiplo: 0,
            idDocumento: "",
            descrizioneUm: "",
            um: 0,
            prezzoUnitario: 0.0,
            quantita: 0,
            sconto: 0.0,
            idArticolo: "",
            descrizione: "",
          },
        ],
      },
      jsonDataAccettazione: { accettazioneAnagrafica: {}, accettazionePrestazioni: {}, accettazioneStati: [], accettazioneStruttura: {}, accettazionePresidio: {} },
      title: "Nuovo Documento",
      fieldsRigheDocumento: [
        {
          label: "N.",
          key: "index",
          sortable: false,
          thStyle: "width: 1em",
        },
        {
          label: this.$i18n.t("billing.lblDescription"),
          key: "descrizione",
          sortable: true,
        },
        {
          label: this.$i18n.t("billing.lblQuantity"),
          key: "quantita",
          sortable: true,
          thStyle: "width: 4em",
        },
        {
          label: this.$i18n.t("billing.lblUnitOfMeasure"),
          key: "descrizioneUm",
          sortable: true,
          thStyle: "width: 4em",
        },
        {
          label: this.$i18n.t("billing.lblAmount"),
          key: "prezzoUnitario",
          sortable: true,
          formatter: (value) => {
            if (value) {
              return value.toLocaleString("it-IT", { style: "currency", currency: "EUR" });
            }
          },
          thStyle: "width: 7em",
        },
        {
          label: "",
          key: "action",
          thStyle: "width: 7rem",
          tdClass: "text-center",
        },
      ],
      customToolbar: [
        ["bold", "italic", "underline", "strike"], // toggled buttons
        [{ align: "" }, { align: "center" }, { align: "right" }, { align: "justify" }],
        [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
        [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
        [{ color: [] }, { background: [] }], // dropdown with defaults from theme
      ],
    };
  },
  methods: {
    openModal(id) {
      let me = this;
      me.title = "Nuova Ricevuta";
      me.idAccettazione = id;
      me.loadDataUmArticolo();
      me.loadDataMultiploArticolo();
      me.loadDataImballoArticolo();
      me.loadDataArticolo();
      me.loadTabellaIva();
      me.loadAccettazione();
    },
    loadAccettazione() {
      let me = this;
      me.showModalLoading = true;
      let link = process.env.VUE_APP_PATH_API + me.pathResourceAccettazione + "/" + me.idAccettazione;
      axios
        .get(link)
        .then((response) => {
          me.jsonDataAccettazione = response.data.data;
          me.showModalLoading = false;
          me.setDatiAnagraficaStruttura();
        })
        .catch(() => {
          me.showModalLoading = false;
        });
    },
    setDatiAnagraficaStruttura() {
      let me = this;
      me.jsonData.stato = "INTERNO";
      me.jsonData.note = "Documento emesso per consegna materiali sanitari.";
      me.jsonData.codiceOperazioneMagazzino = 1;
      me.jsonData.codiceOperazioneContabile = 0;
      me.jsonData.ibanStruttura = me.jsonDataAccettazione.accettazioneStruttura.iban;
      me.jsonData.emailStruttura = me.jsonDataAccettazione.accettazioneStruttura.email;
      me.jsonData.telefonoStruttura = me.jsonDataAccettazione.accettazioneStruttura.telefono;
      me.jsonData.pecStruttura = me.jsonDataAccettazione.accettazioneStruttura.pec;
      me.jsonData.idTipoDocumento = "124e4be7-b345-4245-91de-27905adcacd7";
      me.jsonData.tipoDocumentoDescrizione = "Ricevuta Carico Materiale Paziente";
      me.jsonData.codiceStruttura = me.jsonDataAccettazione.accettazioneStruttura.codiceStruttura;
      me.jsonData.denominazioneStruttura = me.jsonDataAccettazione.accettazioneStruttura.denominazione;
      me.jsonData.dataDocumento = new Date().getTime();
      me.jsonData.trasportoDataOraInizio = new Date().getTime();
      me.jsonData.codiceTipoDocumento = "RCVPZ";
      me.jsonData.idSoggetto = me.jsonDataAccettazione.accettazioneAnagrafica.id;
      me.jsonData.nomeSoggetto = me.jsonDataAccettazione.accettazioneAnagrafica.nome;
      me.jsonData.cognomeRagioneSoggetto = me.jsonDataAccettazione.accettazioneAnagrafica.cognome;
      me.jsonData.provinciaSoggetto = me.jsonDataAccettazione.accettazioneAnagrafica.provinciaResidenza;
      me.jsonData.localitaSoggetto = me.jsonDataAccettazione.accettazioneAnagrafica.comuneResidenza;
      me.jsonData.localitaSoggettoCodiceIstat = me.jsonDataAccettazione.accettazioneAnagrafica.comuneResidenzaCodiceIstat;
      me.jsonData.capSoggetto = me.jsonDataAccettazione.accettazioneAnagrafica.capResidenza;
      me.jsonData.indirizzoSoggetto = me.jsonDataAccettazione.accettazioneAnagrafica.indirizzoResidenza;
      me.jsonData.codiceFiscaleSoggetto = me.jsonDataAccettazione.accettazioneAnagrafica.identificativo;
      me.jsonData.partitaIvaSoggetto = "";
      me.jsonData.codiceDestinatario = me.jsonDataAccettazione.numero;
      me.jsonData.idCausaleDocumento = "1a4ae479-360b-4a60-9e39-f25244bd387a";
      me.jsonData.causaleDocumentoDescrizione = "Carico Armadietto Paziente";
      me.jsonData.causaleDocumentoOperazioneContabile = 0;
      me.jsonData.causaleDocumentoOperazioneMagazzino = 1;
      me.jsonData.idMetodoPagamento = "MP01";
      me.jsonData.metodoPagamentoDescrizione = "Bonifico bancario";
      me.jsonData.magazzinoDescrizione = me.jsonDataAccettazione.accettazioneAnagrafica.cognome + " " + me.jsonDataAccettazione.accettazioneAnagrafica.nome;
      me.jsonData.descrizioneBancaStruttura = "";
      me.jsonData.destinazioneMerceDescrizione = me.jsonDataAccettazione.accettazioneAnagrafica.cognome + " " + me.jsonDataAccettazione.accettazioneAnagrafica.nome;
      me.jsonData.destinazioneMerceCap = "-";
      me.jsonData.destinazioneMerceLocalita = "-";
      me.jsonData.destinazioneMerceIndirizzo = "-";
      me.jsonData.destinazioneMerceProvincia = "-";
      // "capDestinazione": "87100",
      // "indirizzoDestinazione": "Via Ospedale 1",
      // "localitaDestinazioneCodiceIstat": "078045",
      // "localitaDestinazione": "Cosenza",
      // "provinciaDestinazione": "CS",
      // "speseTrasporto": 50.0,
      // "trasportoCura": "Mittente",
      // "trasportoDataOraInizio": "2025-10-09T08:30:00",
      // "marcaBollo": "SI",
      // "marcaBolloImporto": 2.0,
      // "marcaBolloImportoMinimo": 77.47,
      // "marcaBolloNumero": "MB123456",
      // "marcaBolloVirtuale": true,
      me.jsonData.partitaIvaStruttura = me.jsonDataAccettazione.accettazioneStruttura.partitaIva;
      me.jsonData.codiceCausale = "RCVPZ";
      me.jsonData.trasportoCausale = "Consegna diretta al cliente";
      me.$refs.mdlRsaPazienteArmadiettoRicevute.show();
    },
    onCloseModal() {
      let me = this;
      me.closeModal();
    },
    closeModal() {
      let me = this;
      me.jsonData = {
        stato: "",
        note: "",
        codiceOperazioneMagazzino: 0,
        codiceOperazioneContabile: 0,
        ibanStruttura: "",
        emailStruttura: "",
        telefonoStruttura: "",
        pecStruttura: "",
        colli: 0,
        imballo: "",
        vettore: "",
        porto: "",
        noteInterne: "",
        idTipoDocumento: "",
        tipoDocumentoDescrizione: "",
        codiceStruttura: "",
        denominazioneStruttura: "",
        dataDocumento: 0,
        codiceTipoDocumento: "",
        idSoggetto: "",
        nomeSoggetto: "",
        cognomeRagioneSoggetto: "",
        provinciaSoggetto: "",
        localitaSoggetto: "",
        localitaSoggettoCodiceIstat: "",
        capSoggetto: "",
        indirizzoSoggetto: "",
        codiceFiscaleSoggetto: "",
        partitaIvaSoggetto: "",
        codiceDestinatario: "",
        idCausaleDocumento: "",
        causaleDocumentoDescrizione: "",
        causaleDocumentoOperazioneContabile: 0,
        causaleDocumentoOperazioneMagazzino: 0,
        idMetodoPagamento: "",
        metodoPagamentoDescrizione: "",
        totaleImponibileDocumento: 0.0,
        totaleImpostaDocumento: 0.0,
        totaleDocumento: 0.0,
        idMagazzino: "",
        magazzinoDescrizione: "",
        descrizioneBancaStruttura: "",
        capDestinazione: "",
        indirizzoDestinazione: "",
        localitaDestinazioneCodiceIstat: "",
        localitaDestinazione: "",
        provinciaDestinazione: "",
        speseTrasporto: 0.0,
        trasportoCura: "",
        trasportoDataOraInizio: "",
        marcaBollo: "",
        marcaBolloImporto: 0.0,
        marcaBolloImportoMinimo: 0.0,
        marcaBolloNumero: "",
        marcaBolloVirtuale: false,
        partitaIvaStruttura: "",
        codiceCausale: "",
        trasportoCausale: "",
        righeDocumento: [
          {
            aliquotaIva: 0.0,
            descrizioneImballo: "",
            codiceArticolo: "",
            codiceIva: "",
            codiceTipoSpesa: "",
            colli: 0,
            descrizioneIva: "",
            descrizioneMultiplo: "",
            multiploMultiplo: 0,
            idDocumento: "",
            descrizioneUm: "",
            um: 0,
            prezzoUnitario: 0.0,
            quantita: 0,
            sconto: 0.0,
            idArticolo: "",
            descrizione: "",
          },
        ],
      };
      me.$refs.mdlRsaPazienteArmadiettoRicevute.hide();
    },
    onClickSave() {
      let me = this;
      // console.log("onClickSaveReferto", me.jsonData);
      UtilityMixin.methods.saveResource(me.pathResource, me.jsonData, me.saveSuccess, me.saveError);
    },

    saveSuccess(response) {
      let me = this;
      // me.closeModal();
      me.$bvToast.toast("Salvataggio avvvenuto con successo", {
        title: "Success",
        variant: "success",
        solid: true,
      });
      me.$emit("saveSuccess", response);
      me.closeModal();
    },
    saveError(error) {
      let me = this;
      me.$refs.cmpModalError.show(error);
    },
    onClickBack() {
      let me = this;
      me.modalStep = 0;
      me.rigaSelezionata = {};
    },
    onAddRigaDocumento(row) {
      let me = this;
      me.rigaSelezionata = row.item;
      this.modalStep = 1;
    },
    onClickAggiungi() {
      let me = this;
      me.jsonData.righeDocumento.push({
        aliquotaIva: 0.0,
        descrizioneImballo: "",
        codiceArticolo: "",
        codiceIva: "",
        codiceTipoSpesa: "MS001",
        colli: 0,
        descrizioneIva: "",
        descrizioneMultiplo: "",
        multiploMultiplo: 0,
        idDocumento: "",
        descrizioneUm: "",
        um: 0,
        prezzoUnitario: 0.0,
        quantita: 0,
        sconto: 0.0,
        idArticolo: "",
        descrizione: "",
      });
      me.modalStep = 0;
    },
    loadDataUmArticolo() {
      let me = this;
      UtilityMixin.methods.loadDataResources(me.pathResourceUmArticolo, {}, me.loadDataUmArticoloSuccess, me.loadDataUmArticoloError);
    },
    loadDataUmArticoloSuccess(response) {
      let me = this;
      me.umOptions = response.data.data.list.map((item) => ({
        value: item.um,
        text: item.descrizioneUm,
      }));
    },
    loadDataUmArticoloError(error) {
      console.log(error);
    },
    loadDataCategoriaArticolo() {
      let me = this;
      UtilityMixin.methods.loadDataResources(me.pathResourceCategoriaArticolo, {}, me.loadDataCategoriaArticoloSuccess, me.loadDataCategoriaArticoloError);
    },
    loadDataMultiploArticolo() {
      let me = this;
      UtilityMixin.methods.loadDataResources(me.pathResourceMultiploArticolo, {}, me.loadDataMultiploArticoloSuccess, me.loadDataMultiploArticoloError);
    },
    loadDataMultiploArticoloSuccess(response) {
      let me = this;
      me.multiploOptions = response.data.data.list.map((item) => ({
        value: item.multiploMultiplo,
        text: item.descrizioneMultiplo,
      }));
    },
    loadDataMultiploArticoloError(error) {
      console.log(error);
    },
    loadDataImballoArticolo() {
      let me = this;
      UtilityMixin.methods.loadDataResources(me.pathResourceImballoArticolo, {}, me.loadDataImballoArticoloSuccess, me.loadDataImballoArticoloError);
    },
    loadDataImballoArticoloSuccess(response) {
      let me = this;
      // console.log("RISPOSTA IMBALLO", response);
      me.imballoOptions = response.data.data.list.map((item) => ({
        value: item.descrizioneImballo,
        text: item.descrizioneImballo,
      }));
    },
    loadDataImballoArticoloError(error) {
      console.log(error);
    },
    loadDataArticolo() {
      let me = this;
      UtilityMixin.methods.loadDataResources(me.pathResourceArticolo, {}, me.loadDatArticoloSuccess, me.loadDataArticoloError);
    },
    loadDatArticoloSuccess(response) {
      let me = this;
      // console.log("RISPOSTA IMBALLO", response);
      me.articoliOptions = response.data.data.list;
    },
    loadDataArticoloError(error) {
      console.log(error);
    },
    loadTabellaIva() {
      let me = this;
      UtilityMixin.methods.loadDataResources(me.pathResourceTabellaIVA, null, me.loadTabellaIvaSuccess, me.loadTabellaIvaError);
    },
    loadTabellaIvaSuccess(response) {
      let me = this;
      /*  me.codiceIvaOptions = response.data.data; */
      /*  console.log("RISPOSTA TABELLA IVA", response); */

      me.codiceIvaOptions = response.data.data.map((item) => ({
        value: item.codiceIva,
        text: item.descrizioneIva,
      }));
    },
    loadTabellaIvaError(response) {
      console.log(response);
    },
    onChangeArticolo() {
      let me = this;
      console.log(me.rigaSelezionata.codiceArticolo);

      me.articoliOptions.forEach((element) => {
        if (me.rigaSelezionata.codiceArticolo === element.codiceArticolo) {
          me.rigaSelezionata.descrizione = element.descrizioneArticolo;
          me.rigaSelezionata.descrizioneImballo = element.descrizioneImballo;
          me.rigaSelezionata.descrizioneIva = element.descrizioneIva;
          me.rigaSelezionata.codiceIva = element.codiceIva;
          me.rigaSelezionata.prezzoUnitario = element.prezzoAcquistoStandard;
        }
      });
    },
    change() { },
    onCalcolo() { },
    editRicevuta(value) {
      let me = this;
      console.log(me.umOptions);

      me.loadDataUmArticolo();
      me.loadDataMultiploArticolo();
      me.loadDataImballoArticolo();
      me.loadDataArticolo();
      me.loadTabellaIva();
      me.loadDataRicevuta(value);
    },
    loadDataRicevuta(value) {
      let me = this;
      let link = me.pathResource + "/" + value;
      UtilityMixin.methods.loadDataResources(link, {}, me.loadDataRicevutaSuccess, me.loadDataRicevutaError);
    },
    loadDataRicevutaSuccess(response) {
      let me = this;
      me.jsonData = response.data.data;
      me.jsonData.righeDocumento.push({
        aliquotaIva: 0.0,
        descrizioneImballo: "",
        codiceArticolo: "",
        codiceIva: "",
        codiceTipoSpesa: "MS001",
        colli: 0,
        descrizioneIva: "",
        descrizioneMultiplo: "",
        multiploMultiplo: 0,
        idDocumento: "",
        descrizioneUm: "",
        um: 0,
        prezzoUnitario: 0.0,
        quantita: 0,
        sconto: 0.0,
        idArticolo: "",
        descrizione: "",
      });

      me.$refs.mdlRsaPazienteArmadiettoRicevute.show();
    },
    loadDataRicevutaError(error) {
      console.log(error);
    },
  },
};
</script>
<style></style>
